import { DndContext, MouseSensor, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext } from "@dnd-kit/sortable";
import { type FC, type ReactElement } from "react";

import { moveItemsInArray } from "widgets/utils";

import { type IIdentifiable } from "../../redux/modules/table-data.js";
import { DraggableProjectListItem } from "./DraggableProjectListItem.js";

export interface ISelectable extends IIdentifiable {
  selected?: boolean;
}

export interface IGenericOptionsSelectionAndOrderingProps {
  options: ISelectable[];
  disabledSortingTooltip?: string;
  disableSelection?: boolean;
  listUpdated: (options: ISelectable[]) => void;
  renderItem: (item: IIdentifiable) => ReactElement;
  optionClassName?: string;
}

const GenericOptionsSelectionAndOrdering: FC<IGenericOptionsSelectionAndOrderingProps> = (props) => {
  const onCheckboxClick = (event, checkedOption: ISelectable) => {
    const selected: boolean = event.target.checked;

    props.listUpdated(
      props.options.map((option: ISelectable) =>
        option.id === checkedOption.id ? { ...option, selected: selected } : option,
      ),
    );
  };

  const pointerSensor = useSensor(MouseSensor, { activationConstraint: { distance: 5 } });
  const sensors = useSensors(pointerSensor);

  return (
    <DndContext
      sensors={sensors}
      onDragEnd={({ active, over }) => {
        props.listUpdated(moveItemsInArray(props.options, active, over));
      }}
    >
      <SortableContext
        items={props.options.map((option) => String(option.id))}
        disabled={!!props.disabledSortingTooltip}
      >
        {props.options.map((option: ISelectable, index) => (
          <DraggableProjectListItem
            option={option}
            disabledSortingTooltip={props.disabledSortingTooltip}
            disableSelection={props.disableSelection}
            renderItem={props.renderItem}
            index={index}
            onCheckboxClick={onCheckboxClick}
            key={`project-list-item-${index}`}
          />
        ))}
      </SortableContext>
    </DndContext>
  );
};

export default GenericOptionsSelectionAndOrdering;
